import {apiBase} from 'api/base.js';

class CowEventAPI {
  index(farmId, inputPath) {
    return apiBase.get(`/admin/cow_event?farm_id=${farmId}&input_path=${inputPath}`);
  }
}

export const cowEventAPI = new CowEventAPI();
